import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import { BodyTextMedium } from 'LuxKit/Typography/BodyText'
import { slideIn, slideUp } from 'components/utils/animations'
import { bezierCurve } from 'styles/tools/constants'
import landingComposerMessages from './landingComposerMessages'
import { PLACEHOLDER_SLIDE_MS } from './useRotatingPlaceholder'

// Divs, not spans: the composer's textarea wrapper sizes every descendant span to full width.
const Ticker = styled.div`
  ${BodyTextMedium}
  display: flex;
  gap: ${rem(4)};
  color: ${props => props.theme.palette.neutral.default.three};
  white-space: nowrap;
`

const ExampleWindow = styled.div`
  display: grid;
  min-inline-size: 0;
  overflow: hidden;
`

const Example = styled.div`
  grid-area: 1 / 1;
  overflow: hidden;
  text-overflow: ellipsis;

  &.leaving {
    animation: ${slideUp} ${PLACEHOLDER_SLIDE_MS}ms ${bezierCurve} forwards;
  }

  &.entering {
    animation: ${slideIn} ${PLACEHOLDER_SLIDE_MS}ms ${bezierCurve};
  }
`

interface Props {
  example: string
  nextExample: string
  isRotating: boolean
}

/** Visual only: the textarea's own placeholder carries the current example for assistive tech. */
function ChatLandingPlaceholderTicker({ example, nextExample, isRotating }: Props) {
  const intl = useIntl()

  const exampleWindow = (
    <ExampleWindow key="example-window">
      <Example key={example} className={isRotating ? 'leaving' : undefined}>{example}</Example>
      {isRotating && <Example key={nextExample} className="entering">{nextExample}</Example>}
    </ExampleWindow>
  )

  return (
    <Ticker>
      {intl.formatMessage(landingComposerMessages.tryExample, { example: exampleWindow })}
    </Ticker>
  )
}

export default ChatLandingPlaceholderTicker
